// src/styles/index.css caps every [role="tooltip"] (which Popper sets) at z-index 999, below the
// menu's popover; the attribute selector here outranks that global rule.
export const subMenuPopperStyles = ({ zIndex }) => ({
  '&[role=tooltip]': {
    zIndex: zIndex.tooltip,
  },
});
